@if (gridOptions) {
  <dv-grid [actions]="actions">
    <ag-grid-angular
      dvGridInSidesheet
      dvPinSelectedRow
      class="ag-theme-devinco"
      [gridOptions]="gridOptions">
    </ag-grid-angular>
  </dv-grid>
}
